import type { Constructable } from 'bz-utilities/ts';

import {} from 'history';

import MobileDetect from 'mobile-detect';

export type {};

declare global {
  let CKEDITOR: any;

  interface Window {
    debugger?: boolean;
    mobileDetection: MobileDetect;
    browserHistory: any;
    CKEDITOR?: any;
    CKEDITOR_BASEPATH: string;
    Heidi: any;
  }

  function BzNotFalsy<T>(arg: T | undefined | null): arg is T;
  function BzNotNull<T>(arg: T | undefined | null): arg is T;
  function IsInstance<T extends object>(clazz: Constructable<T>, value: any): value is T;
}

Object.defineProperty(window, 'BzNotFalsy', {
  writable: false,
  enumerable: false,
  value: function <T>(arg: T | undefined | null): arg is T {
    return !!arg;
  }
});

Object.defineProperty(window, 'BzNotNull', {
  writable: false,
  enumerable: false,
  value: function <T>(arg: T | undefined | null): arg is T {
    return arg != null;
  }
});

Object.defineProperty(window, 'IsInstance', {
  writable: false,
  enumerable: false,
  value: function <T extends object>(clazz: Constructable<T>, value: any): value is T {
    return value instanceof clazz;
  }
});

window.mobileDetection = new MobileDetect(window.navigator.userAgent);
